import { Link } from 'react-router-dom';
import type { Manga } from '@/mocks/mangas';

interface MangaCardProps {
  manga: Manga;
  showCategory?: boolean;
}

export default function MangaCard({ manga, showCategory = true }: MangaCardProps) {
  return (
    <Link
      to={`/manga/${manga.id}`}
      className="group block cursor-pointer"
      data-product-shop=""
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100 aspect-[3/4]">
        <img
          src={manga.coverImage}
          alt={manga.title}
          title={`${manga.title} - 番茄漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2 flex flex-col gap-1.5">
          {manga.isNew && (
            <span className="px-2 py-0.5 text-xs font-semibold bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
              NEW
            </span>
          )}
          {manga.status === '已完结' && (
            <span className="px-2 py-0.5 text-xs font-semibold bg-foreground-900/80 text-background-50 rounded-md whitespace-nowrap">
              完结
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
          <div className="flex items-center gap-2">
            <span className="text-xs text-background-50/90 flex items-center gap-1">
              <i className="ri-star-fill text-accent-500"></i>
              {manga.rating}
            </span>
            <span className="text-xs text-background-50/70">
              {manga.views >= 10000 ? `${(manga.views / 10000).toFixed(0)}万` : manga.views} 阅读
            </span>
          </div>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
          {manga.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          {showCategory && (
            <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
              {manga.category}
            </span>
          )}
          <span className="text-xs text-foreground-500">
            更新至 {manga.chapters[0]?.number ?? '?'} 话
          </span>
        </div>
      </div>
    </Link>
  );
}